import React from 'react'
import LayoutMain from '../layouts/LayoutMain'
import MyBlock from '../UI/block/MyBlock'
import MyBlockHeader from '../UI/block/MyBlockHeader'

const Home = () => {
  return (
    <LayoutMain>
		<MyBlockHeader
            header={'Головна сторінка обліку'}
            // options={
            //     <PackOptions />
            // }
        />
		<MyBlock>
			<p>Оберіть в меню необхідний розділ</p>
		</MyBlock>
    </LayoutMain>
  )
}

export default Home